import { Button, styled, Typography } from '@mui/material';

export const PageW = styled('div')`
  padding-top: 64px;
  padding-left: 38px;
  position: relative;
  width: 100%;

  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }
`;

export const ContentW = styled('div')`
  display: flex;
  flex-direction: column;

  @media (min-width: 1920px) {
    align-items: center;
  }
`;

export const ColumnsW = styled('div')`
  display: flex;
  gap: 16px;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

export const PageHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  width: 1090px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: 900px;
  }

  @media (max-width: 1023px) {
    margin-bottom: 16px;
  }
`;

export const Column = styled('div')`
  display: flex;
  flex-direction: column;
  width: 537px;
  min-width: 507px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: 442px;
    min-width: 442px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    min-width: 0px;
  }
`;

// TODO: move to shared component - EditButton
export const ButtonW = styled(Button)`
  text-transform: none;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const ActivationStatusValueW = styled('div')`
  @media (max-width: 1023px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const StatusButton = styled(Button)`
  text-transform: none;
  font-size: 12px;
  line-height: 14px;
  border-radius: 8px;
  box-shadow: none;
  padding: 3px 8px;
  background: ${({ theme }) => theme.palette.primary.p040};
  @media (max-width: 1023px) {
    margin-left: 8px;
  }
`;

export const StatusText = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  &.info {
    color: ${({ theme }) => theme.palette.info.main};
  }
  &.warning {
    color: ${({ theme }) => theme.palette.danger.main};
  }
`;

export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  @media (max-width: 1023px) {
    margin-bottom: 0px;
  }
`;

export const RichEditorW = styled('div')`
  padding-top: 20px;
  padding-bottom: 20px;
`;
